export default {
      id: "play-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/icons.7315c2cd.svg#play",
      toString: function () {
        return this.url;
      }
    }